{
  "metadata": {
    "id": "dracula-light",
    "name": "Dracula",
    "description": "Портировано из темы «Dracula» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "dracula.json",
      "project": "dracula",
      "url": "https://github.com/dracula/dracula-theme",
      "upstreamFile": "packages/ui/src/theme/themes/dracula.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 23.4,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.47,
      "paletteMaxS": 0.516,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 21.8,
      "syntaxVsTextMinDeltaE": 23.4,
      "chartsMinDeltaE": 47.7,
      "textSeparationDeltaE": 19.3,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#7c6bf5",
      "hover": "#7060dc",
      "active": "#6658c9",
      "foreground": "#000000",
      "muted": "#7c6bf580",
      "emphasis": "#7c6bf5"
    },
    "surface": {
      "background": "#f8f8f2",
      "foreground": "#1f1f2f",
      "muted": "#c9cac9",
      "mutedForeground": "#46464b",
      "elevated": "#b3b4b6",
      "elevatedForeground": "#1f1f2f",
      "raised": "#98999e",
      "raisedForeground": "#1f1f2f",
      "overlay": "#f8f8f233",
      "subtle": "#e1e1de"
    },
    "interactive": {
      "border": "#919197",
      "borderHover": "#bbbbbb",
      "borderFocus": "#7c6bf5",
      "selection": "#1f1f2f24",
      "selectionForeground": "#1f1f2f",
      "focus": "#7c6bf559",
      "focusRing": "#7c6bf547",
      "cursor": "#1f1f2f",
      "hover": "#1f1f2f17",
      "active": "#1f1f2f24"
    },
    "status": {
      "error": "#d23253",
      "errorForeground": "#ffffff",
      "errorBackground": "#d232531a",
      "errorBorder": "#d2325359",
      "warning": "#ad5a08",
      "warningForeground": "#ffffff",
      "warningBackground": "#ad5a081a",
      "warningBorder": "#ad5a0859",
      "success": "#20824d",
      "successForeground": "#ffffff",
      "successBackground": "#20824d1a",
      "successBorder": "#20824d59",
      "info": "#1b76b8",
      "infoForeground": "#ffffff",
      "infoBackground": "#1b76b81a",
      "infoBorder": "#1b76b859"
    },
    "pr": {
      "open": "#20824d",
      "draft": "#55555b",
      "blocked": "#ad5a08",
      "merged": "#d16090",
      "closed": "#d23253"
    },
    "syntax": {
      "base": {
        "background": "#c9cac9",
        "foreground": "#1f1f2f",
        "comment": "#525366",
        "keyword": "#962b58",
        "string": "#4c5700",
        "number": "#4128f0",
        "function": "#145787",
        "variable": "#1f1f2f",
        "type": "#ad0808",
        "operator": "#265959"
      },
      "tokens": {
        "commentDoc": "#525366",
        "stringEscape": "#265959",
        "keywordImport": "#962b58",
        "storageModifier": "#962b58",
        "functionCall": "#145787",
        "method": "#145787",
        "variableProperty": "#145787",
        "variableOther": "#1f1f2f",
        "variableGlobal": "#4128f0",
        "variableLocal": "#265959",
        "parameter": "#1f1f2f",
        "constant": "#4128f0",
        "class": "#ad0808",
        "className": "#ad0808",
        "interface": "#ad0808",
        "struct": "#ad0808",
        "enum": "#ad0808",
        "typeParameter": "#ad0808",
        "namespace": "#ad0808",
        "module": "#962b58",
        "tag": "#962b58",
        "jsxTag": "#962b58",
        "tagAttribute": "#145787",
        "tagAttributeValue": "#4c5700",
        "boolean": "#4128f0",
        "decorator": "#962b58",
        "label": "#145787",
        "regexp": "#4c5700"
      }
    },
    "charts": {
      "series": [
        "#7c6bf5",
        "#1b76b8",
        "#20824d",
        "#ad5a08",
        "#d23253"
      ]
    },
    "chat": {
      "background": "#f8f8f2",
      "userMessage": "#1f1f2f",
      "userMessageBackground": "#b3b4b6",
      "assistantMessage": "#1f1f2f",
      "assistantMessageBackground": "#c9cac9",
      "timestamp": "#55555b",
      "divider": "#919197",
      "typing": "#55555b"
    },
    "loading": {
      "spinner": "#7c6bf5",
      "spinnerTrack": "#c9cac9",
      "skeleton": "#c9cac9",
      "shimmer": "#bfc0c0"
    },
    "tools": {
      "background": "#c9cac9",
      "border": "#919197",
      "headerHover": "#c0c1c1",
      "icon": "#6753f3",
      "title": "#1f1f2f",
      "description": "#55555b",
      "edit": {
        "added": "#20824d",
        "addedBackground": "#20824d1a",
        "removed": "#d23253",
        "removedBackground": "#d232531a",
        "modified": "#1b76b8",
        "modifiedBackground": "#1b76b81a",
        "lineNumber": "#55555b"
      }
    },
    "markdown": {
      "heading1": "#1f1f2f",
      "heading2": "#1f1f2f",
      "heading3": "#1f1f2f",
      "heading4": "#1f1f2f",
      "link": "#6b58f4",
      "linkHover": "#6c5cdb",
      "inlineCode": "#4c5700",
      "inlineCodeBackground": "#c9cac9",
      "blockquote": "#55555b",
      "blockquoteBorder": "#919197",
      "listMarker": "#7866f5",
      "bold": "#1f1f2f",
      "italic": "#1f1f2fe6",
      "strikethrough": "#55555b",
      "hr": "#919197"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#d19199",
        "foreground": "#000000",
        "contrast": 8.22
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c2614a",
        "foreground": "#000000",
        "contrast": 5.1
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#bb8d57",
        "foreground": "#000000",
        "contrast": 7.06
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d5d17c",
        "foreground": "#000000",
        "contrast": 13.24
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#9eca59",
        "foreground": "#000000",
        "contrast": 11.05
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#a4d596",
        "foreground": "#000000",
        "contrast": 12.54
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#59c874",
        "foreground": "#000000",
        "contrast": 9.94
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#5bc8af",
        "foreground": "#000000",
        "contrast": 10.33
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#95c8d4",
        "foreground": "#000000",
        "contrast": 11.49
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4d8ec2",
        "foreground": "#000000",
        "contrast": 5.96
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4564be",
        "foreground": "#ffffff",
        "contrast": 5.5
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#6248bc",
        "foreground": "#ffffff",
        "contrast": 6.62
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a471cc",
        "foreground": "#000000",
        "contrast": 5.81
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d292cc",
        "foreground": "#000000",
        "contrast": 8.72
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c34eac",
        "foreground": "#000000",
        "contrast": 5.01
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c24c77",
        "foreground": "#ffffff",
        "contrast": 4.57
      }
    ]
  }
}
